import styled from 'styled-components'
import { fullViewHeight } from './styles'

export const StyledSpinner = {
  Wrapper: styled.div`
    ${fullViewHeight};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  ComplexAnimatedCircle: styled.div`
    width: 100px;
  `,
}
